import { render } from "./RankingThird.vue?vue&type=template&id=ca7b9bf4&scoped=true&ts=true&lang=pug"
import script from "./RankingThird.vue?vue&type=script&lang=ts"
export * from "./RankingThird.vue?vue&type=script&lang=ts"

import "./RankingThird.vue?vue&type=style&index=0&id=ca7b9bf4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca7b9bf4"]])

export default __exports__